import { formatEuro, splitFare } from "@/lib/api";

const Row = ({ label, value, testid, strong, accent }) => (
  <div className="flex items-center justify-between gap-3 py-2.5 border-b border-[#27272A] last:border-b-0">
    <span className={`text-sm ${strong ? "text-white font-semibold" : "text-[#94A3B8]"}`}>{label}</span>
    <span data-testid={testid} className={`ff-display text-xl font-extrabold whitespace-nowrap ${accent || "text-white"}`}>{value}</span>
  </div>
);

export const FeeSplit = ({ fare }) => {
  const { total, executor, platform } = splitFare(fare);
  return (
    <div data-testid="fee-split" className="rounded-xl border border-[#27272A] bg-black px-4 py-1.5">
      <Row label="Tariffa Totale (€)" value={formatEuro(total)} testid="fee-total-amount" strong />
      <Row label="Spettante al Collega Cedente (90%):" value={formatEuro(executor)} testid="fee-executor-amount" accent="text-[#10B981]" />
      <Row label="Quota di Gestione Piattaforma FLEETFLOW (10%):" value={formatEuro(platform)} testid="fee-platform-amount" />
    </div>
  );
};
